export interface IBlock {
  id: number;
  singleActionBody: any;
}

export const processingGroupByEmptyBlock = (block?: Partial<IBlock>): IBlock => ({
  id: 0,
  singleActionBody: {},
  ...block
});
